import { openExplore } from "./exploreState"
import { QUESTIONS } from "./questions"
import { startQuiz } from "./quizState"
import { openVerify } from "./verifyState"

export function Home() {
  const unverifiedCount = QUESTIONS.filter((q) => q.status === "unverified").length

  return (
    <>
      <div class="hero-stamp">
        <span>Unofficial Practice Test</span>
        <span>Based on the Kansas Driving Handbook</span>
      </div>

      <h1 class="hero-title">
        Prepare
        <br />
        for the
        <br />
        <em>written</em>
        <br />
        exam.
      </h1>

      <div class="screen-section">
        <h2 class="section-heading">Handbook</h2>
        <a
          class="handbook-link"
          href="https://www.ksrevenue.gov/pdf/dlhb.pdf"
          target="_blank"
          rel="noopener noreferrer"
          referrerpolicy="no-referrer"
        >
          <span class="handbook-link-label">Kansas Driving Handbook (PDF)</span>
          <span class="handbook-link-url">www.ksrevenue.gov/pdf/dlhb.pdf</span>
        </a>
      </div>

      <div class="screen-section">
        <h2 class="section-heading">Practice</h2>
        <div class="mode-grid">
          <button type="button" class="mode-card" onClick={() => startQuiz("practice-short")}>
            <div class="mode-count">15</div>
            <div class="mode-text">
              <div class="mode-name">Short Practice</div>
              <div class="mode-desc">A shorter test drawn from across all sections.</div>
            </div>
            <div class="mode-arrow">→</div>
          </button>

          <button type="button" class="mode-card" onClick={() => startQuiz("practice-full")}>
            <div class="mode-count">25</div>
            <div class="mode-text">
              <div class="mode-name">Practice Test</div>
              <div class="mode-desc">
                Questions drawn from across all sections, matching the length of the real knowledge test.
              </div>
            </div>
            <div class="mode-arrow">→</div>
          </button>
        </div>
      </div>

      <div class="screen-section">
        <h2 class="section-heading">Study</h2>
        <div class="mode-grid">
          <button type="button" class="mode-card" onClick={() => startQuiz("study")}>
            <div class="mode-count">08</div>
            <div class="mode-text">
              <div class="mode-name">Study Quiz</div>
              <div class="mode-desc">Questions weighted toward unseen content and recent misses.</div>
            </div>
            <div class="mode-arrow">→</div>
          </button>

          <button type="button" class="mode-card mode-card-cta" onClick={openExplore}>
            <div class="mode-text">
              <div class="mode-name">Study Guide</div>
              <div class="mode-desc">
                A curated study guide based on your progress, bookmarks, and recently missed questions.
              </div>
            </div>
            <div class="mode-arrow">→</div>
          </button>
        </div>
      </div>

      <div class="source-note">
        <strong>Source.</strong> Questions and correct answers are transcribed directly from the Kansas Driving Handbook
        (Feb 2023 revision). This site isn't affiliated with the Kansas Department of Revenue.
      </div>

      {unverifiedCount > 0 && (
        <div class="home-footer">
          <button type="button" class="verify-link" onClick={openVerify}>
            Verify {unverifiedCount} unverified question{unverifiedCount === 1 ? "" : "s"} →
          </button>
        </div>
      )}
    </>
  )
}
